<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_4"></a><a id="Copyright">Copyright © Christian Prag 2009<br/>
Translated from the German by Lawrence Paterson<br/>
Translation © Seaforth Publishing 2009</a></p><a id="Copyright">
<p class="copyright3">First published in Great Britain in 2009 by<br/>
Seaforth Publishing<br/>
An imprint of Pen &amp; Sword Books Ltd<br/>
47 Church Street, Barnsley<br/>
S Yorkshire S70 2AS</p>
</a><p class="copyright3"><a id="Copyright"></a><a href="http://www.seaforthpublishing.com" target="_blank">www.seaforthpublishing.com</a><br/>
Email <a href="mailto:info@seaforthpublishing.com">info@seaforthpublishing.com</a></p>
<p class="copyright3">British Library Cataloguing in Publication Data<br/>
A CIP data record for this book is available from the British Library</p>
<p class="copyright3">ISBN 978-1-84832-022-2<br/>
PDF ISBN: 978-1-78346-547-7<br/>
EPUB ISBN: 978-1-78383-013-8<br/>
PRC ISBN: 978-1-78346-780-8</p>
<p class="copyright3">All rights reserved. No part of this publication may be reproduced<br/>
or transmitted in any form or by any means, electronic or mechanical,<br/>
including photocopying, recording, or any information storage<br/>
and retrieval system, without prior permission in writing<br/>
of both the copyright owner and the above publisher.</p>
<p class="copyright3">The right of Christian Prag to be identified as the author<br/>
of this work has been asserted by him in accordance with the<br/>
Copyright, Designs and Patents Act 1988.</p>
<p class="copyright3">Typeset by Palindrome<br/>
Printed in Great Britain by the MPG Books Group</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?5daa99bc